import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ProductPage from "./pages/ProductPage";
import ScrollToTopButton from "./components/ScrollToTopButton";

// ✅ Import Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <marquee bgcolor="#1e3a8a" style={{ color: "white", padding: "10px"}}>
        Welcome to MICRO-WELL INDUSTRIES. Our Business hours are Monday to Saturday from 9:00 AM to 6:00 PM
      </marquee>
      <Navbar />
      <main className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/product/:slug" element={<ProductPage />} />
        </Routes>
      </main>
      <ScrollToTopButton />

      <Footer />

      {/* ✅ Global Toast Container */}
      <ToastContainer position="top-right" autoClose={2000} />
    </Router>
  );
}

export default App;
